/**
 * 결제 상태 레이블 및 스타일 유틸리티
 * FSD: shared/lib/payment
 */

import type { TransactionStatus, SubscriptionStatus } from '@/entities/payment/model';

export const TRANSACTION_STATUS_LABELS: Record<TransactionStatus, string> = {
  PENDING: '⏳ 처리 중',
  APPROVED: '✓ 완료',
  CANCELLED: '✕ 취소됨',
  FAILED: '✗ 실패',
};

export const SUBSCRIPTION_STATUS_LABELS: Record<SubscriptionStatus | string, string> = {
  ACTIVE: '✓ 활성 (정기결제 진행 중)',
  PAUSED: '⏸ 일시중지됨',
  CANCELLED: '✕ 취소됨',
};

export const getStatusClass = (status: string): string => {
  return `status-${status.toLowerCase()}`;
};

export const getStatusBadge = (status: TransactionStatus): string => {
  return TRANSACTION_STATUS_LABELS[status] || status;
};

export const getSubscriptionStatusBadge = (status: string): string => {
  return SUBSCRIPTION_STATUS_LABELS[status] || status;
};
